import * as actionTypes from './actionTypes';
import axios from '../config/axios';
import { modifyAuthError } from '../utils/utils';
import sha256 from 'js-sha256';


const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

const authSuccess = data => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        payload: data
    };
};

const authFailed = error => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};


export const getAuthToken = ({ username, password, remember }) => {
    return async dispatch => {
        const authData = { password: sha256(password), username };
        const url = '/customers/login/';
        dispatch( authStart() );
        try {
            const response = await axios.post(url, authData);
            if (remember) {
                const { auth_token, username, pk, restaurant_id } = response.data;
                localStorage.setItem('foodna_portal_token', auth_token);
                localStorage.setItem('foodna_portal_username', username);
                localStorage.setItem('foodna_portal_pk', pk);
                localStorage.setItem('foodna_restaurant_id', restaurant_id);
            }
            dispatch(authSuccess(response.data));
        } catch (e) {
            const error = modifyAuthError(e);
            dispatch( authFailed(error) );
        }
    };
};

export const signOut = () => {
    localStorage.removeItem('foodna_portal_token');
    localStorage.removeItem('foodna_portal_username');
    localStorage.removeItem('foodna_portal_pk');
    localStorage.removeItem('foodna_restaurant_id');
    return {
        type: actionTypes.AUTH_SIGNOUT
    };
};


export const setAuthRedirectPath = path => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        payload: path
    };
};

export const authCheckState = () => {
    return dispatch => {
        const auth_token = localStorage.getItem('foodna_portal_token');
        if (!auth_token) {
            dispatch(signOut());
        } else {
            const username = localStorage.getItem('foodna_portal_username');
            const pk = localStorage.getItem('foodna_portal_pk');
            const restaurant_id = localStorage.getItem('foodna_restaurant_id');
            dispatch(authSuccess({auth_token, username, pk, restaurant_id }));
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/auth.js